import React from "react";

interface StatCardProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  colorTheme: "purple" | "green" | "olive";
  isLoading?: boolean;
}

// Map theme names to CSS variable names
const themeVarMap = {
  purple: "var(--su-icon-purple)",
  green: "var(--su-icon-green)",
  olive: "var(--su-icon-olive)",
};

const StatCard: React.FC<StatCardProps> = ({
  icon,
  label,
  value,
  colorTheme,
  isLoading = false,
}) => {
  return (
    <div className="su-stat-card">
      {/* Top row: Icon + Label */}
      <div className="su-stat-card-top">
        <div 
          className="su-stat-card-icon"
          style={{ backgroundColor: themeVarMap[colorTheme] }}
        >
          {icon}
        </div>
        <div className="su-stat-card-label">
          {label}
        </div>
      </div>
      
      {/* Bottom row: Large value */}
      <div className="su-stat-card-value">
        {isLoading ? (
          <div className="h-10 w-16 bg-gray-800 animate-pulse" />
        ) : (
          value
        )}
      </div>
    </div>
  );
};

export default StatCard;
